import { useDuckSidebarResize } from "duck/ui/chat/hooks";
import { ChatProviderProps } from "duck/ui/chat/types";

import { DuckSidebarResizeContext } from "./useDuckSidebarResizeContext";

export const DuckSidebarResizeContextProvider = ({
  children,
}: ChatProviderProps) => {
  const value = useDuckSidebarResize();

  return (
    <DuckSidebarResizeContext.Provider value={value}>
      {children}
    </DuckSidebarResizeContext.Provider>
  );
};
